var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mini-map",attrs:{"id":_vm.data.name+_vm.data.task_id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }